export default __webpack_public_path__ + "static/media/wh_ep2_quinn.965a2616.jpg";